"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalReducer = exports.headerReducer = exports.formReducer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _actions = require("./actions");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var formReducer = function formReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    formData: {},
    loanId: '',
    errorFields: [],
    achFromBE: false,
    showConfirmationPage: false,
    navigationToNextPage: 'false',
    mandatoryFields: ['rNumber', 'aNumber', 'FIName', 'caNumber', 'fname', 'lname', 'aType'],
    currentFocus: ''
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actions.UPDATE_FORM_READY_TO_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        showConfirmationPage: action.payload.showConfirmationPage
      });
    case _actions.ACH_SUBMIT_INPROGRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFocus: action.payload.currentFocus,
        navigationToNextPage: action.payload.navigationToNextPage
      });
    case _actions.SUBMIT_ACH_INFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFocus: action.payload.currentFocus,
        navigationToNextPage: action.payload.navigationToNextPage
      });
    case _actions.GET_BANK_NAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFocus: action.payload.currentFocus,
        errorFields: action.payload.errorFields,
        formData: action.payload.formData
      });
    case _actions.UPDATE_FORM_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFocus: action.payload.currentFocus,
        formData: action.payload.formData
      });
    case _actions.MOCK_FORM:
      return _objectSpread(_objectSpread({}, state), {}, {
        formData: action.payload.formData
      });
    case _actions.ADD_VALIDATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorFields: action.payload.errorFields
      });
    default:
      return state;
  }
};
exports.formReducer = formReducer;
var headerReducer = function headerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    default:
      return state;
  }
};
exports.headerReducer = headerReducer;
var modalReducer = function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isOpen: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actions.UPDATE_MODAL_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: action.payload.isOpen
      });
    default:
      return state;
  }
};
exports.modalReducer = modalReducer;
